class TeaserBlocks {
  /**
   * @param {string} sectionId
   */
  constructor(sectionId) {
    this.sectionId = sectionId;
    /** @type {HTMLImageElement | null} */
    this.mainImage = /** @type {HTMLImageElement | null} */ (document.getElementById(`teaser-main-image-${sectionId}`));
    /** @type {NodeListOf<HTMLElement>} */
    this.blocks = document.querySelectorAll(`#shopify-section-${sectionId} .teaser-block`);
    /** @type {string | null} */
    this.originalImageSrc = null;
    
    if (this.mainImage) {
      this.originalImageSrc = this.mainImage.getAttribute('data-original-image') || this.mainImage.src;
    }
    
    this.init();
  }
  
  init() {
    if (!this.mainImage || this.blocks.length === 0) {
      return;
    }
    
    this.blocks.forEach((block) => {
      const blockImage = block.getAttribute('data-block-image');
      
      if (!blockImage) {
        return;
      }
      
      block.addEventListener('mouseenter', () => {
        this.handleBlockHover(blockImage);
      });
      
      block.addEventListener('mouseleave', () => {
        this.handleBlockLeave();
      });
    });
  }
  
  /**
   * @param {string} blockImageSrc
   */
  handleBlockHover(blockImageSrc) {
    if (!this.mainImage || !blockImageSrc) {
      return;
    }
    
    this.mainImage.style.opacity = '0';
    
    setTimeout(() => {
      if (this.mainImage) {
        this.mainImage.src = blockImageSrc;
        this.mainImage.style.opacity = '1';
      }
    }, 150);
  }
  
  handleBlockLeave() {
    if (!this.mainImage || !this.originalImageSrc) {
      return;
    }
    
    this.mainImage.style.opacity = '0';
    
    setTimeout(() => {
      if (this.mainImage && this.originalImageSrc) {
        this.mainImage.src = this.originalImageSrc;
        this.mainImage.style.opacity = '1';
      }
    }, 150);
  }
}

/**
 * @param {HTMLElement} sectionElement
 */
function initTeaserSection(sectionElement) {
  if (!sectionElement) return;
  
  const sectionId = sectionElement.id.replace('shopify-section-', '');
  const hasBlocks = sectionElement.querySelector('.teaser-blocks');
  
  if (hasBlocks && sectionId) {
    const existingInstance = /** @type {any} */ (sectionElement)._teaserInstance;
    
    /** @type {any} */ (sectionElement)._teaserInstance = new TeaserBlocks(sectionId);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTeaserSections);
} else {
  initAllTeaserSections();
}

function initAllTeaserSections() {
  const teaserSections = document.querySelectorAll('[id^="shopify-section-"]');
  
  teaserSections.forEach((section) => {
    initTeaserSection(/** @type {HTMLElement} */ (section));
  });
}

if (typeof document.addEventListener !== 'undefined') {
  document.addEventListener('shopify:section:load', (/** @type {CustomEvent} */ event) => {
    const sectionElement = event.detail?.container || event.detail;
    
    if (sectionElement) {
      if (sectionElement instanceof HTMLElement) {
        initTeaserSection(sectionElement);
      } else if (sectionElement.querySelector) {
        initTeaserSection(sectionElement);
      } else {
        const sectionId = sectionElement.id || sectionElement.sectionId;
        if (sectionId) {
          const element = document.getElementById(`shopify-section-${sectionId}`);
          if (element) {
            initTeaserSection(element);
          }
        }
      }
    }
  });
}

